import React, {
  FC,
  useEffect,
  useState,
  useCallback,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../_metronic/helpers'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import isBetween from 'dayjs/plugin/isBetween'
import {Mainsubtable2} from '../tables/Mainsubtable2'
import {Column} from 'react-table'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)
dayjs.extend(isBetween)

const truncate = require('truncate')
const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const SALES_TAX_MADE = process.env.REACT_APP_SALES_TAX

export const Printingsalesinvoice = forwardRef((props: any, ref: any) => {

  const columnaddedtitems: ReadonlyArray<
    Column<{
      product_name: string
      quantity: number
      unit_price: number
      sub_total: number
    }>
  > = [
    {
      Header:  () => <div>Name</div>,
      accessor: 'product_name',
      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark fw-bolder d-block mb-1 fs-6'>{value}</span>
        </>
      ),
    },
    {
      Header: () => <div className='text-end'>Quantity</div>,
      accessor: 'quantity',

      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6 text-end'>
            {addCommas(Number(value).toFixed(2))}
          </span>
        </>
      ),
    },
    {
      Header: () => <div className='text-end'>Price</div>,
      accessor: 'unit_price',
      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6 text-end'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },
    {
      Header: () => <div className='text-end'>Total</div>,
      accessor: 'sub_total',
      Cell: ({cell: {value}, row}) => (
        <>
          <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6 text-end'>
            {addCommas(Number(value).toFixed(2))} {CURRENCY_APP}
          </span>
        </>
      ),
    },
  ]




  return (
    <>
    
    <style>
        {`
        @media print {
          @page {
            margin: 20mm;
          }
         
        }
        `}
      </style>
      
      <div className='printingClass' >
        <div ref={ref}  className='container'>
         
        <div className='py-5 px-5 border rounded'>
          <div className='row'>
            <div className='col-6'>
              <div className='d-flex justify-content-start mb-2'>
                <img
                  alt='Logo'
                  className='h-30px logo'
                  src={toAbsoluteUrl('/media/logos/default-light.svg')}
                />
              </div>
              <div className='d-flex justify-content-start'>
                <span className='text-muted mt-1 fw-bold fs-5'>Roysambu, Nairobi</span>
              </div>
              <div className='d-flex justify-content-start'>
                <span className='text-muted mt-1 fw-bold fs-5'>Tel: +254723456454</span>
              </div>
            </div>
            <div className='col-6'>
              <div className='d-flex justify-content-end'>
                <h1 className='text-primary'>Sales Invoice</h1>
              </div>
              <div className='d-flex justify-content-end'>
                <span className='text-muted mt-1 fw-bold fs-5'>No: {props.invoiceid}</span>
              </div>
            </div>
          </div>
          <div className='row mt-10'>
            <div className='col-6'>
              <div className='d-flex justify-content-start'>
                <h5 className='text-dark'>Bill To:</h5>
              </div>
              <div className='d-flex justify-content-start'>
                <span className='text-muted mt-1 fw-bold fs-5'>Peter Micheal</span>
              </div>
              <div className='d-flex justify-content-start'>
                <span className='text-muted mt-1 fw-bold fs-5'>Tel: +254723456454</span>
              </div>
              <div className='d-flex justify-content-start'>
                <span className='text-muted mt-1 fw-bold fs-5'>Kahawa Sukari, Nairobi</span>
              </div>
            </div>
            <div className='col-6'>
              <div className='d-flex justify-content-end'>
                <h5 className='text-dark'>Invoice Date:</h5>
              </div>
              <div className='d-flex justify-content-end'>
                <span className='text-muted mt-1 fw-bold fs-5'>{dayjs().format('LL')}</span>
              </div>

              <div className='d-flex justify-content-end mt-5'>
                <h5 className='text-dark'>Due Date:</h5>
              </div>
              <div className='d-flex justify-content-end'>
                <span className='text-muted mt-1 fw-bold fs-5'>
                  {dayjs().add(10, 'day').format('LL')}
                </span>
              </div>
            </div>
          </div>
            </div>
          <div className='mt-10'>
          <div className='py-5 px-5 border rounded'>
            <Mainsubtable2
              columnaddedtitems={columnaddedtitems}
              adddatatable={props.adddatatable}
            />
            
          
          <div className='row mt-2'>
            <div className='col-6 d-flex justify-content-start'>
              <span>Thank you for your business</span>
            </div>
            <div className='col-6 d-flex justify-content-end'>
              <div className='border-top border-bottom border-dark py-3'>
                <span className='fs-5 fw-bolder mt-3'>
                  <span className='me-3'>Total:</span>
                  <span className='text-primary text-end'>
                    {addCommas(props.allsubtotalsmade.toFixed(2))} {CURRENCY_APP}
                  </span>
                </span>
              </div>
            </div>
          </div>
          </div>
          </div>
          <div className='py-5 px-5 border rounded mt-10'>
          <div className='row'>
          
            <div className='col-6'>
              <div className='d-flex justify-content-start'>
                <h5 className='text-dark'>Payment Options:</h5>
              </div>
              <div className='d-flex justify-content-start'>
                <span className='text-muted mt-1 fw-bold fs-5'>MPESA TILL: 5459633</span>
              </div>
              <div className='d-flex justify-content-start'>
                <span className='text-muted mt-1 fw-bold fs-5'>BANK ACCOUNT: 2045412272</span>
              </div>
              
            </div>
            <div className='col-6'>
             
            </div>
            </div>
          </div>
        
      </div>
      </div>
    </>
  )
})
